export async function subscribeToNewsletter(email) {
  const response = await fetch('/api/newsletter', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.success) {
    throw new Error(payload.detail || payload.message || 'Failed to subscribe. Please try again.');
  }
  return payload;
}
